function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.messenger_st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;fill-opacity:0;}\n\t.messenger_st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#bubble_1_);}\n\t.messenger_st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "bounding-box",
  className: "messenger_st0",
  width: 512,
  height: 512
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "bubble",
  className: "messenger_st1",
  d: "M256,0C111.8,0,0,105.6,0,248.3C0,323,30.6,387.4,80.4,432c4.2,3.7,6.7,9,6.9,14.6l1.4,45.5 c0.4,14.5,15.4,24,28.7,18.1l50.8-22.4c4.3-1.9,9.1-2.3,13.7-1c23.3,6.4,48.2,9.8,74.1,9.8c144.2,0,256-105.6,256-248.3 S400.2,0,256,0z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "bolt",
  className: "messenger_st2",
  d: "M102.3,320.9l75.2-119.3c12-19,37.6-23.7,55.5-10.2l59.8,44.9c5.5,4.1,13,4.1,18.5-0.1l80.8-61.3 c10.8-8.2,24.9,4.7,17.6,16.2l-75.2,119.3c-12,19-37.6,23.7-55.5,10.2l-59.8-44.9c-5.5-4.1-13-4.1-18.5,0.1l-80.8,61.3 C109.1,345.3,95.1,332.4,102.3,320.9z"
});

function SvgMessenger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_2_",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bubble_1_",
    cx: 67.8982,
    cy: 661.3284,
    r: 0.6973,
    gradientTransform: "matrix(800 0 0 -799.9999 -54220 529571.9375)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0099FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6098,
    style: {
      stopColor: "#A033FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9348,
    style: {
      stopColor: "#FF5280"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7061"
    }
  })), _ref4, _ref5));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.e1aa4958.svg";
export { ForwardRef as ReactComponent };